import type { QueryClient } from '@tanstack/react-query';

/** Точка самовывоза на странице заказов — привязана к предыдущему продавцу. */
export const ORDERS_PICKUP_POINT_STORAGE_KEY = 'orders-page-pickup-point-id';

/**
 * Полный сброс клиентского состояния кабинета продавца:
 * заказы, бонусы, чаты поддержки, чаты по заказам и прочий React Query кэш.
 */
export async function clearSellerClientState(queryClient: QueryClient): Promise<void> {
  await queryClient.cancelQueries();
  queryClient.clear();
  try {
    localStorage.removeItem(ORDERS_PICKUP_POINT_STORAGE_KEY);
  } catch {
    // ignore
  }
}
